var map = {
	"./arg.png": 246,
	"./aus.png": 247,
	"./bel.png": 248,
	"./bra.png": 249,
	"./che.png": 250,
	"./col.png": 251,
	"./cri.png": 252,
	"./default.png": 253,
	"./deu.png": 254,
	"./dnk.png": 255,
	"./egy.png": 256,
	"./eng.png": 257,
	"./esp.png": 258,
	"./fra.png": 259,
	"./hrv.png": 260,
	"./ira.png": 261,
	"./irn.png": 262,
	"./isl.png": 263,
	"./jap.png": 264,
	"./kor.png": 265,
	"./mar.png": 266,
	"./mex.png": 267,
	"./nga.png": 268,
	"./pan.png": 269,
	"./per.png": 270,
	"./pol.png": 271,
	"./prt.png": 272,
	"./rus.png": 273,
	"./sau.png": 274,
	"./sen.png": 275,
	"./srb.png": 276,
	"./swe.png": 277,
	"./tun.png": 278,
	"./ury.png": 279
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;



//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/flags ^\.\/.*$
// module id = 65
// module chunks = 35783957827783